// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exercise-workspace {
  min-height: calc(100vh - 132px);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.workspace-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1.5rem;
}

.workspace-header h1 {
  margin: 0.35rem 0 0;
  color: #2c3e50;
  font-size: clamp(1.35rem, 2vw, 1.8rem);
}

.workspace-description {
  margin-top: 0.4rem;
  color: #64748b;
  font-size: 0.925rem;
}

.back-link {
  color: #3498db;
  text-decoration: none;
  font-size: 0.875rem;
}

.back-link:hover {
  text-decoration: underline;
}

.save-indicator {
  flex: 0 0 auto;
  color: #52715d;
  font-size: 0.875rem;
  padding: 0.45rem 0.7rem;
  border-radius: 999px;
  background: #edf7ef;
}

.save-indicator.is-saving {
  color: #855d16;
  background: #fff5dc;
}

.workspace-container {
  display: grid;
  grid-template-columns: minmax(190px, 230px) minmax(0, 1fr);
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
}

/* Sidebar */
.workspace-sidebar {
  background: white;
  border: 1px solid #e5eaf0;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 4px 14px rgba(24, 39, 75, 0.06);
  align-self: start;
}

.sidebar-heading {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.9rem;
}

.sidebar-heading h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 1rem;
}

.sidebar-heading > span {
  color: #64748b;
  font-size: 0.75rem;
  white-space: nowrap;
}

.task-progress-track {
  height: 6px;
  overflow: hidden;
  margin-bottom: 1rem;
  border-radius: 999px;
  background: #e9eef4;
}

.task-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #27ae60;
  transition: width 0.25s ease;
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.task-item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #e7ebf0;
  border-radius: 9px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.task-item:hover:not(.locked) {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.task-item.active {
  background-color: #eff7ff;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.12);
}

.task-item.passed {
  background-color: #f3faf4;
}

.task-item.locked {
  opacity: 0.58;
  cursor: not-allowed;
}

.task-status-icon {
  display: grid;
  flex: 0 0 1.65rem;
  width: 1.65rem;
  height: 1.65rem;
  place-items: center;
  border-radius: 50%;
  background: #eef2f6;
  color: #64748b;
  font-size: 0.8rem;
}

.task-item.active .task-status-icon {
  background: #dbeeff;
  color: #1976b9;
}

.task-item.passed .task-status-icon {
  background: #dff3e3;
  color: #21834b;
}

.task-copy {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  gap: 0.15rem;
}

.task-step {
  color: #718096;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.task-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.35;
}

.task-status-label {
  color: #64748b;
  font-size: 0.68rem;
  white-space: nowrap;
}

.task-status-label.current {
  color: #1976b9;
}

.task-status-label.passed {
  color: #21834b;
}

/* Main workspace */
.workspace-main {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-width: 0;
}

.exercise-complete-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 760px;
  width: 100%;
  margin: auto;
  padding: clamp(1.5rem, 4vw, 2.5rem);
  overflow: hidden;
  border: 1px solid #d9e9df;
  border-radius: 18px;
  background:
    radial-gradient(ellipse at top right, rgba(39, 174, 96, 0.12), transparent 45%),
    linear-gradient(145deg, #fff 0%, #f7fcf8 100%);
  box-shadow: 0 14px 38px rgba(28, 92, 55, 0.1);
}

.completion-mark {
  display: grid;
  width: 3rem;
  height: 3rem;
  margin-bottom: 1rem;
  place-items: center;
  border-radius: 50%;
  background: #e2f5e8;
  color: #21834b;
  font-size: 1.4rem;
  font-weight: 700;
}

.completion-eyebrow {
  color: #21834b;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.exercise-complete-card h2 {
  margin: 0.35rem 0 0;
  color: #243449;
  font-size: clamp(1.5rem, 3vw, 2rem);
}

.exercise-complete-card > p {
  max-width: 520px;
  margin: 0.6rem 0 1.5rem;
  color: #64748b;
  line-height: 1.65;
}

.quiz-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 1rem 1.15rem;
  border: 1px solid #21834b;
  border-radius: 12px;
  background: linear-gradient(110deg, #21834b, #27ae60);
  box-shadow: 0 6px 14px rgba(33, 131, 75, 0.2);
  color: #fff;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.quiz-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(33, 131, 75, 0.26);
  filter: brightness(1.04);
}

.quiz-cta:focus-visible {
  outline: 3px solid rgba(52, 152, 219, 0.65);
  outline-offset: 3px;
}

.quiz-cta-copy {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.quiz-cta-copy strong {
  font-size: 1.05rem;
}

.quiz-cta-copy span {
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.85rem;
}

.quiz-cta-arrow {
  display: grid;
  flex: 0 0 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.17);
  font-size: 1.35rem;
  transition: transform 0.18s ease;
}

.quiz-cta:hover .quiz-cta-arrow {
  transform: translateX(3px);
}

.task-instructions {
  background: white;
  border: 1px solid #e5eaf0;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 4px 14px rgba(24, 39, 75, 0.06);
}

.task-instructions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.85rem;
}

.eyebrow {
  color: #3498db;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.task-instructions h2 {
  margin: 0.2rem 0 0;
  color: #2c3e50;
  font-size: 1.15rem;
}

.current-task-status {
  flex: 0 0 auto;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: #eaf5ff;
  color: #1976b9;
  font-size: 0.75rem;
  font-weight: 600;
}

.current-task-status.passed {
  background: #eaf7ed;
  color: #21834b;
}

.instruction-content {
  max-height: min(28vh, 240px);
  overflow: auto;
  padding: 0.85rem 1rem;
  border: 1px solid #e8edf2;
  border-radius: 8px;
  background: #f8fafc;
}

.instructions-text {
  white-space: pre-wrap;
  color: #475569;
  line-height: 1.6;
}

.instructions-text code,
.instruction-list code {
  padding: 0.1rem 0.3rem;
  border-radius: 4px;
  background: #e9eef5;
  color: #334155;
  font-size: 0.92em;
}

.instruction-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin: 0;
  padding-left: 1.65rem;
  color: #475569;
  line-height: 1.5;
}

.instruction-list li {
  padding-left: 0.25rem;
}

.instruction-list li::marker {
  color: #3498db;
  font-weight: 700;
}

.task-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-top: 0.9rem;
}

.task-actions .btn {
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
}

.hints-box {
  margin-top: 1rem;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 1rem;
}

.hints-box h4 {
  margin: 0 0 0.5rem 0;
  color: #856404;
}

.hint-item {
  margin: 0.5rem 0;
  color: #856404;
  font-size: 0.875rem;
}

/* Editor and Preview */
.editor-preview-container {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 1rem;
  min-height: 520px;
  height: clamp(520px, 68vh, 820px);
}

.editor-section,
.preview-section {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

.file-tabs {
  display: flex;
  flex: 0 0 auto;
  overflow-x: auto;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.file-tab {
  flex: 0 0 auto;
  padding: 0.7rem 1rem;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #64748b;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.875rem;
}

.file-tab:hover {
  background: #e9ecef;
}

.file-tab.active {
  background: white;
  border-bottom-color: #3498db;
  font-weight: 600;
  color: #2c3e50;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 0.7rem 1rem;
  border-bottom: 1px solid #dee2e6;
  font-size: 0.875rem;
  font-weight: 600;
  color: #2c3e50;
}

.preview-hint {
  color: #718096;
  font-size: 0.72rem;
  font-weight: 400;
}

.preview-frame {
  flex: 1 1;
  min-height: 0;
  border: none;
  background: white;
}

/* Test Results */
.test-results {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.test-results h3 {
  margin: 0 0 1rem 0;
  color: #2c3e50;
}

.test-results.success h3 {
  color: #27ae60;
}

.test-results.failure h3 {
  color: #e74c3c;
}

.test-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.test-item {
  display: flex;
  gap: 1rem;
  padding: 0.75rem;
  border-radius: 4px;
  border-left: 4px solid;
}

.test-item.passed {
  background: #d4edda;
  border-left-color: #27ae60;
}

.test-item.failed {
  background: #f8d7da;
  border-left-color: #e74c3c;
}

.test-icon {
  font-size: 1.25rem;
  font-weight: bold;
}

.test-item.passed .test-icon {
  color: #27ae60;
}

.test-item.failed .test-icon {
  color: #e74c3c;
}

.test-details {
  flex: 1 1;
}

.test-name {
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #2c3e50;
}

.test-message {
  font-size: 0.875rem;
  color: #555;
}

.btn-block {
  width: 100%;
}

@media (max-width: 900px) {
  .workspace-container {
    grid-template-columns: minmax(190px, 220px) minmax(0, 1fr);
    gap: 0.85rem;
  }

  .editor-preview-container {
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
    gap: 0.75rem;
    min-height: 460px;
    height: clamp(460px, 62vh, 680px);
  }

  .editor-section,
  .preview-section {
    min-height: 0;
  }
}

@media (max-width: 1050px) {
  .workspace-container {
    grid-template-columns: minmax(0, 1fr);
  }

  .workspace-sidebar {
    align-self: start;
  }

  .task-list {
    flex-direction: row;
    overflow-x: auto;
    padding: 0.15rem 0.1rem 0.5rem;
  }

  .task-item {
    flex: 0 0 210px;
  }
}

@media (max-width: 760px) {
  .editor-preview-container {
    grid-template-columns: 1fr;
    height: auto;
  }

  .editor-section,
  .preview-section {
    min-height: 360px;
  }
}

@media (max-width: 700px) {
  .exercise-workspace {
    min-height: 0;
  }

  .workspace-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.75rem;
  }

  .workspace-container {
    grid-template-columns: 1fr;
    min-height: 0;
  }

  .workspace-sidebar {
    padding: 1rem;
  }

  .task-list {
    flex-direction: row;
    overflow-x: auto;
    padding: 0.15rem 0.1rem 0.5rem;
  }

  .task-item {
    flex: 0 0 min(280px, 82vw);
  }

  .task-instructions {
    padding: 1rem;
  }

  .instruction-content {
    max-height: 38vh;
  }

  .editor-preview-container {
    min-height: 0;
    height: auto;
  }

  .editor-section,
  .preview-section {
    min-height: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/student/ExerciseWorkspace.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;kDAEgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,6CAA6C;EAC7C,WAAW;EACX,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,0DAA0D;IAC1D,YAAY;EACd;;EAEA;IACE,sDAAsD;IACtD,YAAY;IACZ,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".exercise-workspace {\r\n  min-height: calc(100vh - 132px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.workspace-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.workspace-header h1 {\r\n  margin: 0.35rem 0 0;\r\n  color: #2c3e50;\r\n  font-size: clamp(1.35rem, 2vw, 1.8rem);\r\n}\r\n\r\n.workspace-description {\r\n  margin-top: 0.4rem;\r\n  color: #64748b;\r\n  font-size: 0.925rem;\r\n}\r\n\r\n.back-link {\r\n  color: #3498db;\r\n  text-decoration: none;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.back-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.save-indicator {\r\n  flex: 0 0 auto;\r\n  color: #52715d;\r\n  font-size: 0.875rem;\r\n  padding: 0.45rem 0.7rem;\r\n  border-radius: 999px;\r\n  background: #edf7ef;\r\n}\r\n\r\n.save-indicator.is-saving {\r\n  color: #855d16;\r\n  background: #fff5dc;\r\n}\r\n\r\n.workspace-container {\r\n  display: grid;\r\n  grid-template-columns: minmax(190px, 230px) minmax(0, 1fr);\r\n  gap: 1rem;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n/* Sidebar */\r\n.workspace-sidebar {\r\n  background: white;\r\n  border: 1px solid #e5eaf0;\r\n  border-radius: 12px;\r\n  padding: 1.25rem;\r\n  box-shadow: 0 4px 14px rgba(24, 39, 75, 0.06);\r\n  align-self: start;\r\n}\r\n\r\n.sidebar-heading {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n  gap: 0.5rem;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.sidebar-heading h2 {\r\n  margin: 0;\r\n  color: #2c3e50;\r\n  font-size: 1rem;\r\n}\r\n\r\n.sidebar-heading > span {\r\n  color: #64748b;\r\n  font-size: 0.75rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.task-progress-track {\r\n  height: 6px;\r\n  overflow: hidden;\r\n  margin-bottom: 1rem;\r\n  border-radius: 999px;\r\n  background: #e9eef4;\r\n}\r\n\r\n.task-progress-track span {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: #27ae60;\r\n  transition: width 0.25s ease;\r\n}\r\n\r\n.task-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.task-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  width: 100%;\r\n  padding: 0.8rem;\r\n  border: 1px solid #e7ebf0;\r\n  border-radius: 9px;\r\n  background: #fff;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.task-item:hover:not(.locked) {\r\n  background-color: #f8fafc;\r\n  border-color: #cbd5e1;\r\n}\r\n\r\n.task-item.active {\r\n  background-color: #eff7ff;\r\n  border-color: #3498db;\r\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.12);\r\n}\r\n\r\n.task-item.passed {\r\n  background-color: #f3faf4;\r\n}\r\n\r\n.task-item.locked {\r\n  opacity: 0.58;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.task-status-icon {\r\n  display: grid;\r\n  flex: 0 0 1.65rem;\r\n  width: 1.65rem;\r\n  height: 1.65rem;\r\n  place-items: center;\r\n  border-radius: 50%;\r\n  background: #eef2f6;\r\n  color: #64748b;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.task-item.active .task-status-icon {\r\n  background: #dbeeff;\r\n  color: #1976b9;\r\n}\r\n\r\n.task-item.passed .task-status-icon {\r\n  background: #dff3e3;\r\n  color: #21834b;\r\n}\r\n\r\n.task-copy {\r\n  display: flex;\r\n  flex: 1;\r\n  min-width: 0;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.task-step {\r\n  color: #718096;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.task-title {\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  line-height: 1.35;\r\n}\r\n\r\n.task-status-label {\r\n  color: #64748b;\r\n  font-size: 0.68rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.task-status-label.current {\r\n  color: #1976b9;\r\n}\r\n\r\n.task-status-label.passed {\r\n  color: #21834b;\r\n}\r\n\r\n/* Main workspace */\r\n.workspace-main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.85rem;\r\n  min-width: 0;\r\n}\r\n\r\n.exercise-complete-card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  max-width: 760px;\r\n  width: 100%;\r\n  margin: auto;\r\n  padding: clamp(1.5rem, 4vw, 2.5rem);\r\n  overflow: hidden;\r\n  border: 1px solid #d9e9df;\r\n  border-radius: 18px;\r\n  background:\r\n    radial-gradient(ellipse at top right, rgba(39, 174, 96, 0.12), transparent 45%),\r\n    linear-gradient(145deg, #fff 0%, #f7fcf8 100%);\r\n  box-shadow: 0 14px 38px rgba(28, 92, 55, 0.1);\r\n}\r\n\r\n.completion-mark {\r\n  display: grid;\r\n  width: 3rem;\r\n  height: 3rem;\r\n  margin-bottom: 1rem;\r\n  place-items: center;\r\n  border-radius: 50%;\r\n  background: #e2f5e8;\r\n  color: #21834b;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.completion-eyebrow {\r\n  color: #21834b;\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.exercise-complete-card h2 {\r\n  margin: 0.35rem 0 0;\r\n  color: #243449;\r\n  font-size: clamp(1.5rem, 3vw, 2rem);\r\n}\r\n\r\n.exercise-complete-card > p {\r\n  max-width: 520px;\r\n  margin: 0.6rem 0 1.5rem;\r\n  color: #64748b;\r\n  line-height: 1.65;\r\n}\r\n\r\n.quiz-cta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  width: 100%;\r\n  padding: 1rem 1.15rem;\r\n  border: 1px solid #21834b;\r\n  border-radius: 12px;\r\n  background: linear-gradient(110deg, #21834b, #27ae60);\r\n  box-shadow: 0 6px 14px rgba(33, 131, 75, 0.2);\r\n  color: #fff;\r\n  text-decoration: none;\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\r\n}\r\n\r\n.quiz-cta:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 10px 20px rgba(33, 131, 75, 0.26);\r\n  filter: brightness(1.04);\r\n}\r\n\r\n.quiz-cta:focus-visible {\r\n  outline: 3px solid rgba(52, 152, 219, 0.65);\r\n  outline-offset: 3px;\r\n}\r\n\r\n.quiz-cta-copy {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.quiz-cta-copy strong {\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.quiz-cta-copy span {\r\n  color: rgba(255, 255, 255, 0.86);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.quiz-cta-arrow {\r\n  display: grid;\r\n  flex: 0 0 2.5rem;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  place-items: center;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.17);\r\n  font-size: 1.35rem;\r\n  transition: transform 0.18s ease;\r\n}\r\n\r\n.quiz-cta:hover .quiz-cta-arrow {\r\n  transform: translateX(3px);\r\n}\r\n\r\n.task-instructions {\r\n  background: white;\r\n  border: 1px solid #e5eaf0;\r\n  border-radius: 12px;\r\n  padding: 1.25rem 1.5rem;\r\n  box-shadow: 0 4px 14px rgba(24, 39, 75, 0.06);\r\n}\r\n\r\n.task-instructions-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 0.85rem;\r\n}\r\n\r\n.eyebrow {\r\n  color: #3498db;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.07em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.task-instructions h2 {\r\n  margin: 0.2rem 0 0;\r\n  color: #2c3e50;\r\n  font-size: 1.15rem;\r\n}\r\n\r\n.current-task-status {\r\n  flex: 0 0 auto;\r\n  padding: 0.35rem 0.65rem;\r\n  border-radius: 999px;\r\n  background: #eaf5ff;\r\n  color: #1976b9;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.current-task-status.passed {\r\n  background: #eaf7ed;\r\n  color: #21834b;\r\n}\r\n\r\n.instruction-content {\r\n  max-height: min(28vh, 240px);\r\n  overflow: auto;\r\n  padding: 0.85rem 1rem;\r\n  border: 1px solid #e8edf2;\r\n  border-radius: 8px;\r\n  background: #f8fafc;\r\n}\r\n\r\n.instructions-text {\r\n  white-space: pre-wrap;\r\n  color: #475569;\r\n  line-height: 1.6;\r\n}\r\n\r\n.instructions-text code,\r\n.instruction-list code {\r\n  padding: 0.1rem 0.3rem;\r\n  border-radius: 4px;\r\n  background: #e9eef5;\r\n  color: #334155;\r\n  font-size: 0.92em;\r\n}\r\n\r\n.instruction-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.55rem;\r\n  margin: 0;\r\n  padding-left: 1.65rem;\r\n  color: #475569;\r\n  line-height: 1.5;\r\n}\r\n\r\n.instruction-list li {\r\n  padding-left: 0.25rem;\r\n}\r\n\r\n.instruction-list li::marker {\r\n  color: #3498db;\r\n  font-weight: 700;\r\n}\r\n\r\n.task-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.65rem;\r\n  margin-top: 0.9rem;\r\n}\r\n\r\n.task-actions .btn {\r\n  padding: 0.6rem 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.hints-box {\r\n  margin-top: 1rem;\r\n  background: #fff3cd;\r\n  border: 1px solid #ffc107;\r\n  border-radius: 4px;\r\n  padding: 1rem;\r\n}\r\n\r\n.hints-box h4 {\r\n  margin: 0 0 0.5rem 0;\r\n  color: #856404;\r\n}\r\n\r\n.hint-item {\r\n  margin: 0.5rem 0;\r\n  color: #856404;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Editor and Preview */\r\n.editor-preview-container {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\r\n  gap: 1rem;\r\n  min-height: 520px;\r\n  height: clamp(520px, 68vh, 820px);\r\n}\r\n\r\n.editor-section,\r\n.preview-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  overflow: hidden;\r\n}\r\n\r\n.file-tabs {\r\n  display: flex;\r\n  flex: 0 0 auto;\r\n  overflow-x: auto;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.file-tab {\r\n  flex: 0 0 auto;\r\n  padding: 0.7rem 1rem;\r\n  border: 0;\r\n  border-bottom: 2px solid transparent;\r\n  background: transparent;\r\n  color: #64748b;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.file-tab:hover {\r\n  background: #e9ecef;\r\n}\r\n\r\n.file-tab.active {\r\n  background: white;\r\n  border-bottom-color: #3498db;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n}\r\n\r\n.preview-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: #f8f9fa;\r\n  padding: 0.7rem 1rem;\r\n  border-bottom: 1px solid #dee2e6;\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n}\r\n\r\n.preview-hint {\r\n  color: #718096;\r\n  font-size: 0.72rem;\r\n  font-weight: 400;\r\n}\r\n\r\n.preview-frame {\r\n  flex: 1;\r\n  min-height: 0;\r\n  border: none;\r\n  background: white;\r\n}\r\n\r\n/* Test Results */\r\n.test-results {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.test-results h3 {\r\n  margin: 0 0 1rem 0;\r\n  color: #2c3e50;\r\n}\r\n\r\n.test-results.success h3 {\r\n  color: #27ae60;\r\n}\r\n\r\n.test-results.failure h3 {\r\n  color: #e74c3c;\r\n}\r\n\r\n.test-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.test-item {\r\n  display: flex;\r\n  gap: 1rem;\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  border-left: 4px solid;\r\n}\r\n\r\n.test-item.passed {\r\n  background: #d4edda;\r\n  border-left-color: #27ae60;\r\n}\r\n\r\n.test-item.failed {\r\n  background: #f8d7da;\r\n  border-left-color: #e74c3c;\r\n}\r\n\r\n.test-icon {\r\n  font-size: 1.25rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.test-item.passed .test-icon {\r\n  color: #27ae60;\r\n}\r\n\r\n.test-item.failed .test-icon {\r\n  color: #e74c3c;\r\n}\r\n\r\n.test-details {\r\n  flex: 1;\r\n}\r\n\r\n.test-name {\r\n  font-weight: 600;\r\n  margin-bottom: 0.25rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.test-message {\r\n  font-size: 0.875rem;\r\n  color: #555;\r\n}\r\n\r\n.btn-block {\r\n  width: 100%;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .workspace-container {\r\n    grid-template-columns: minmax(190px, 220px) minmax(0, 1fr);\r\n    gap: 0.85rem;\r\n  }\r\n\r\n  .editor-preview-container {\r\n    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);\r\n    gap: 0.75rem;\r\n    min-height: 460px;\r\n    height: clamp(460px, 62vh, 680px);\r\n  }\r\n\r\n  .editor-section,\r\n  .preview-section {\r\n    min-height: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 1050px) {\r\n  .workspace-container {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .workspace-sidebar {\r\n    align-self: start;\r\n  }\r\n\r\n  .task-list {\r\n    flex-direction: row;\r\n    overflow-x: auto;\r\n    padding: 0.15rem 0.1rem 0.5rem;\r\n  }\r\n\r\n  .task-item {\r\n    flex: 0 0 210px;\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .editor-preview-container {\r\n    grid-template-columns: 1fr;\r\n    height: auto;\r\n  }\r\n\r\n  .editor-section,\r\n  .preview-section {\r\n    min-height: 360px;\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .exercise-workspace {\r\n    min-height: 0;\r\n  }\r\n\r\n  .workspace-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .workspace-container {\r\n    grid-template-columns: 1fr;\r\n    min-height: 0;\r\n  }\r\n\r\n  .workspace-sidebar {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .task-list {\r\n    flex-direction: row;\r\n    overflow-x: auto;\r\n    padding: 0.15rem 0.1rem 0.5rem;\r\n  }\r\n\r\n  .task-item {\r\n    flex: 0 0 min(280px, 82vw);\r\n  }\r\n\r\n  .task-instructions {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .instruction-content {\r\n    max-height: 38vh;\r\n  }\r\n\r\n  .editor-preview-container {\r\n    min-height: 0;\r\n    height: auto;\r\n  }\r\n\r\n  .editor-section,\r\n  .preview-section {\r\n    min-height: 320px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
